import { createSelector } from "@reduxjs/toolkit";
const selectUserPermissions = (state)=>state.auth.currentUser?.permissions;
export const selectPagePermissions = createSelector([
    selectUserPermissions
], (userPermissions)=>{
    const canReadStatus = userPermissions?.some((p)=>p.action === "read" && p.scope === "status" && p.resource === "system_management") ?? false;
    const canDownloadLogs = userPermissions?.some((p)=>p.action === "read" && p.scope === "logs" && p.resource === "system_management") ?? false;
    const canReadQseed = userPermissions?.some((p)=>p.action === "read" && p.scope === "qseed" && p.resource === "qseed") ?? false;
    const canWriteQseed = userPermissions?.some((p)=>p.action === "write" && p.scope === "qseed" && p.resource === "qseed") ?? false;
    const canReadOutboundStreams = userPermissions?.some((p)=>p.action === "read" && p.scope === "stream_destinations" && p.resource === "outbound_entropy_stream_management") ?? false;
    const canWriteOutboundStreams = userPermissions?.some((p)=>p.action === "write" && p.scope === "stream_destinations" && p.resource === "outbound_entropy_stream_management") ?? false;
    const canReadIPsecTunnels = userPermissions?.some((p)=>p.action === "read" && p.scope === "ipsec" && p.resource === "ipsec_tunnels") ?? false;
    const canWriteIPsecTunnels = userPermissions?.some((p)=>p.action === "write" && p.scope === "ipsec" && p.resource === "ipsec_tunnels") ?? false;
    const canReadUsers = userPermissions?.some((p)=>p.action === "read" && p.scope === "users" && p.resource === "user_management") ?? false;
    const canReadRoles = userPermissions?.some((p)=>p.action === "read" && p.scope === "roles" && p.resource === "user_management") ?? false;
    const canReadPermissions = userPermissions?.some((p)=>p.action === "read" && p.scope === "permissions" && p.resource === "user_management") ?? false;
    const canWriteUsers = userPermissions?.some((p)=>p.action === "write" && p.scope === "users" && p.resource === "user_management") ?? false;
    const canWriteRoles = userPermissions?.some((p)=>p.action === "write" && p.scope === "roles" && p.resource === "user_management") ?? false;
    const canReadApiKeys = userPermissions?.some((p)=>p.action === "read" && p.scope === "api_keys" && p.resource === "api_keys") ?? false;
    const canWriteApiKeys = userPermissions?.some((p)=>p.action === "write" && p.scope === "api_keys" && p.resource === "api_keys") ?? false;
    const canReadBLASTEndpoints = userPermissions?.some((p)=>p.action === "read" && p.scope === "blast_endpoints" && p.resource === "blast_endpoints") ?? false;
    const canWriteBLASTEndpoints = userPermissions?.some((p)=>p.action === "write" && p.scope === "blast_endpoints" && p.resource === "blast_endpoints") ?? false;
    const canWriteCluster = userPermissions?.some((p)=>p.action === "write" && p.scope === "cluster" && p.resource === "cluster_management") ?? false;
    const pagePermissions = {
        canReadStatus,
        canDownloadLogs,
        canReadUtilization: canReadStatus,
        canReadQseed,
        canWriteQseed,
        canReadOutboundStreams,
        canWriteOutboundStreams,
        canReadIPsecTunnels,
        canWriteIPsecTunnels,
        canReadUsers: canReadUsers && canReadRoles && canReadPermissions,
        canWriteUsers: canWriteUsers && canWriteRoles,
        canReadApiKeys,
        canWriteApiKeys,
        canReadBLASTEndpoints,
        canWriteBLASTEndpoints,
        canWriteCluster
    };
    return pagePermissions;
});
